var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUltrasonido(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.58 102",
    style: {
      enableBackground: "new 0 0 141.58 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000111911837247862219910000014557098473305389952_);}\r\n\t.st2{fill:url(#SVGID_00000045621389991025579090000017114392935367946125_);}\r\n\t.st3{fill:url(#SVGID_00000008850905794713103250000017532222592022376116_);}\r\n\t.st4{fill:url(#SVGID_00000144306266943016084660000008573391791915935639_);}\r\n\t.st5{fill:url(#SVGID_00000093158257545939621630000005367297774431090853_);}\r\n\t.st6{fill:url(#SVGID_00000134209150646903749940000000728706417068626061_);}\r\n\t.st7{fill:url(#SVGID_00000054944698117245868530000011897849156885934727_);}\r\n\t.st8{fill:url(#SVGID_00000164509784597279307070000010211037341054962051_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.7281,
    y1: 34.9603,
    x2: 132.8269,
    y2: 107.9938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.81,50.97C5.76,33.76,12.62,17.23,24.84,5.09c0.93-0.95,0.9-2.48-0.04-3.4c-0.94-0.92-2.43-0.92-3.36,0 c-27.26,27.22-27.26,71.36-0.01,98.59c0,0,0,0,0.01,0c0.92,0.95,2.44,0.96,3.39,0.04c0.96-0.93,0.98-2.45,0.05-3.39 c-0.02-0.01-0.04-0.04-0.05-0.05C12.62,84.73,5.76,68.21,5.81,50.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008856946704486086040000008959788226070936455_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5292,
    y1: -4.0255,
    x2: 153.0842,
    y2: 69.008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008856946704486086040000008959788226070936455_)"
    },
    d: "M120.13,1.69 c-0.95-0.93-2.48-0.9-3.39,0.04c-0.92,0.94-0.92,2.43,0,3.37c25.37,25.34,25.37,66.43,0,91.78c-0.95,0.93-0.98,2.45-0.05,3.4 c0.93,0.95,2.45,0.96,3.41,0.04c0.01-0.01,0.02-0.02,0.04-0.04C147.4,73.06,147.4,28.92,120.13,1.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089576393168865200580000017306149286069334427_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.5579,
    y1: 30.7838,
    x2: 134.9971,
    y2: 103.8173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089576393168865200580000017306149286069334427_)"
    },
    d: "M20.26,50.97 c-0.04-13.39,5.29-26.24,14.8-35.69c0.93-0.95,0.9-2.48-0.04-3.4c-0.94-0.92-2.43-0.92-3.36,0c-21.62,21.59-21.62,56.59-0.01,78.19 c0,0,0,0,0.01,0c0.92,0.95,2.44,0.97,3.4,0.04c0.95-0.93,0.97-2.44,0.04-3.39c-0.01-0.01-0.02-0.04-0.04-0.05 C25.55,77.23,20.22,64.38,20.26,50.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072279214560895404540000013787640044658534556_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.36,
    y1: 0.1492,
    x2: 150.9151,
    y2: 73.1827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072279214560895404540000013787640044658534556_)"
    },
    d: "M109.93,11.89 c-0.96-0.93-2.48-0.9-3.4,0.04c-0.92,0.94-0.92,2.42,0,3.37c19.73,19.71,19.73,51.67,0,71.38c-0.95,0.93-0.98,2.45-0.05,3.4 c0.93,0.95,2.45,0.97,3.41,0.04c0.01-0.01,0.02-0.02,0.04-0.04C131.55,68.49,131.55,33.47,109.93,11.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053531218212172468240000001916089383622815876_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.3968,
    y1: 26.6246,
    x2: 137.1582,
    y2: 99.6581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053531218212172468240000001916089383622815876_)"
    },
    d: "M34.69,50.97 c-0.03-9.57,3.78-18.74,10.57-25.5c0.92-0.97,0.87-2.48-0.1-3.39c-0.93-0.88-2.38-0.88-3.29,0c-15.99,15.96-15.99,41.82-0.01,57.79 c0,0,0,0,0.01,0c0.92,0.95,2.44,0.96,3.39,0.04c0.96-0.92,0.98-2.44,0.05-3.39c-0.01-0.01-0.04-0.02-0.05-0.05 C38.47,69.73,34.66,60.56,34.69,50.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082342710659843212160000009385544558188129678_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.1877,
    y1: 4.3298,
    x2: 148.7428,
    y2: 77.3633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082342710659843212160000009385544558188129678_)"
    },
    d: "M99.71,22.09 c-0.95-0.93-2.47-0.9-3.39,0.04c-0.92,0.94-0.92,2.43,0,3.37c14.09,14.07,14.09,36.91,0,50.98c-0.95,0.93-0.98,2.45-0.05,3.4 c0.93,0.95,2.45,0.97,3.41,0.04c0.01-0.01,0.02-0.02,0.04-0.04c15.99-15.96,15.99-41.82,0.01-57.79 C99.71,22.09,99.71,22.09,99.71,22.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016037434579907496990000015885630293122590130_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.2059,
    y1: 22.4082,
    x2: 139.3491,
    y2: 95.4417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016037434579907496990000015885630293122590130_)"
    },
    d: "M55.48,32.29c-0.94-0.94-2.47-0.94-3.41,0 c-10.32,10.33-10.32,27.06,0,37.39c0.96,0.93,2.48,0.89,3.41-0.06c0.9-0.93,0.9-2.4,0-3.34c-8.44-8.45-8.44-22.14,0-30.6 C56.42,34.75,56.42,33.23,55.48,32.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163049866898510563620000009002768072282092700_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.0156,
    y1: 8.5102,
    x2: 146.5706,
    y2: 81.5437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163049866898510563620000009002768072282092700_)"
    },
    d: "M89.5,32.29c-0.95-0.93-2.48-0.9-3.39,0.06 c-0.9,0.93-0.9,2.4,0,3.33c8.44,8.45,8.44,22.14,0,30.6c-0.96,0.93-0.98,2.45-0.06,3.4c0.93,0.95,2.45,0.98,3.41,0.06 c0.01-0.03,0.04-0.04,0.05-0.06C99.82,59.34,99.82,42.62,89.5,32.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098933349327342285670000005767178541072019380_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4101,
    y1: 15.449,
    x2: 142.9651,
    y2: 88.4825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098933349327342285670000005767178541072019380_)"
    },
    d: "M70.8,43.77c3.99,0,7.21,3.23,7.21,7.2 c0,3.99-3.22,7.22-7.21,7.22c-3.99,0-7.23-3.23-7.23-7.22C63.57,47,66.8,43.77,70.8,43.77z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltrasonido);
export default __webpack_public_path__ + "static/media/ultrasonido.c2c6abac4856f6f81c15cd28b89eecfd.svg";
export { ForwardRef as ReactComponent };